<template>
<v-container 
  fluid 
  fill-height 
  justify-center
  align-center
>
  <v-flex xs12 sm12 md8 lg4>
    <v-card>
      <v-toolbar color="primary">
        <v-toolbar-title class="white--text">Login</v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-flex>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-text-field
              label="E-mail"
              v-model="email"
              required
            ></v-text-field>
            <v-text-field
                @keyup.enter="login"
                name="input-10-1"
                label="Password"
                hint="At least 8 characters"
                v-model="password"
                min="8"
                :append-icon="e1 ? 'visibility' : 'visibility_off'"
                :append-icon-cb="() => (e1 = !e1)"
                :type="e1 ? 'password' : 'text'"
                counter
              ></v-text-field>
            <v-btn
              @click.prevent="login"
              :disabled="!valid"
            >
              login
            </v-btn>
            <v-btn @click="clear">clear</v-btn>
          </v-form>
          <div row>
            <v-flex>
              <v-alert
                class="auth"
                color="error"
                icon="check_circle"
                :value="alert"
                transition="scale-transition"
              >
                {{ errorMessage }}
              </v-alert>
            </v-flex>
          </div>
        </v-flex>
      </v-card-title>
      <v-footer>
            <p><br />Forgot your password? You can reset it <router-link to="/auth/reset">here</router-link>.</p>
          </v-footer>
    </v-card>
  </v-flex>
</v-container>
</template>

<script>
import axios from "axios";
  export default {
    data: () => ({
      valid: true,
      password: '',
      email: '',
      e1: true,
      alert: false,
      errorMessage: ''
    }),
    methods: {
      alerting(){
        this.alert = !this.alert;
        setTimeout(() => {
              this.alert = !this.alert;
          }, 3500);
      },
      login () {
        let vm = this;
        this.valid = false;
         axios.post('/login', {
            email: this.email,
            password: this.password
          })
          .then(res => {
            this.$auth.setToken(res.data.access_token, Date.now() + 28800000)
            this.$auth.setAdmin(res.data.is_admin)
            if (res.data.is_admin == true){
              this.$router.push('/admin');
            }else {
              this.$router.push('/agency');
            }
          })
          .catch(function (error) {
            vm.errorMessage = error.response.data.message || 'Username or password is not valid.';
            vm.alerting();
            vm.valid = true;
          });
      },
      clear () {
        this.$refs.form.reset()
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue